"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _checkSourceTypes = require("@studio/sources/checkSourceTypes");
var _attachAudioPresenterSources = require("@studio/sources/attachAudioPresenterSources");
var _getProgramLayers = require("@studio/program/utils/getProgramLayers");
var _sceneBuilder = require("@studio/program/sceneBuilder/sceneBuilder");
var _sceneLayoutSelector = require("@studio/program/sceneLayout/sceneLayoutSelector");
var _SceneLayouts = require("@studio/constants/SceneLayouts");
var _showNotification = _interopRequireDefault(require("../notification/showNotification"));
var _setSceneLayout = _interopRequireDefault(require("./setSceneLayout"));
var _sources = require("../../utils/sources");
var _commonWebAnalytics = require("@studio/metrics/client/web/commonWebAnalytics");
var _sendToDatadogWithIds = require("../../utils/sendToDatadogWithIds");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function toggleSourceProgram(source, setProgram) {
  return function (dispatch, getState) {
    var _getState = getState(),
      sceneLayout = _getState.sceneLayout,
      sceneLayers = _getState.sceneLayers,
      banners = _getState.banners,
      _getState$backgrounds = _getState.backgrounds,
      backgrounds = _getState$backgrounds === void 0 ? undefined : _getState$backgrounds,
      _getState$attendeeMut = _getState.attendeeMuteStatus,
      attendeeMuteStatus = _getState$attendeeMut === void 0 ? {} : _getState$attendeeMut,
      broadcastSources = _getState.broadcastSources,
      program = _getState.program,
      brandingSettings = _getState.brandingSettings;
    var currentBackground = true;
    var layers = (0, _getProgramLayers.getProgramLayers)(program);
    var scene = null;
    var combinedLayers = [].concat(_toConsumableArray(sceneLayers), _toConsumableArray(banners));
    // Check if source exists in program layer
    var layerSource = layers.find(function (layer) {
      return layer.source._id === source._id;
    });
    var sources = (0, _sources.getBroadcastSourcesFromLayers)(layers, broadcastSources.sources);

    /**
     * Get new scene layout based on the source type
     * If source type is audio, don't change scene layout
     */
    var isPresenterSource = (0, _checkSourceTypes.isCameraPresenter)(source);
    var newSceneLayout = (0, _checkSourceTypes.isAudioSource)(source) ? sceneLayout : (0, _sceneLayoutSelector.selectSceneLayout)(sceneLayout, source, sources);
    var withAudioPresenterSources = (0, _attachAudioPresenterSources.attachAudioPresenterSources)(sources, attendeeMuteStatus);

    // If layer source exist, remove it from program sources
    if (layerSource) {
      var newSources = withAudioPresenterSources.filter(function (source) {
        return source._id !== layerSource.source._id;
      });
      scene = (0, _sceneBuilder.sceneBuilder)(newSceneLayout, newSources, combinedLayers, {}, {}, brandingSettings === null || brandingSettings === void 0 ? void 0 : brandingSettings.fonts);
    } else {
      // source does not exist, add it to program.
      if ((0, _sources.willExceedCameraLimit)(sources, source)) {
        // we will not change the scene since we are on the limit but only display notification to inform the user that the limit is attained.
        dispatch((0, _showNotification["default"])("You're at the max of ".concat(_SceneLayouts.CAMERA_PRESENTER_LIMIT, " sources available at a time in program."), {
          timeout: 3500,
          type: 'alert'
        }));
      } else {
        var combinedSources = (0, _sources.combineSources)(sources, source);
        var orderedSources = isPresenterSource ? combinedSources.sort(function (a, b) {
          return a.order - b.order;
        }) : combinedSources;
        var _withAudioPresenterSources = (0, _attachAudioPresenterSources.attachAudioPresenterSources)(orderedSources, attendeeMuteStatus);
        scene = (0, _sceneBuilder.sceneBuilder)(newSceneLayout, _withAudioPresenterSources, combinedLayers, {}, {}, brandingSettings === null || brandingSettings === void 0 ? void 0 : brandingSettings.fonts);
      }
    }
    backgrounds && (currentBackground = backgrounds.find(function (b) {
      var _program$style;
      return b._id === (program === null || program === void 0 || (_program$style = program.style) === null || _program$style === void 0 ? void 0 : _program$style.backgroundId) && b.source.hidden === false;
    }));
    if (scene) {
      var _scene;
      scene = _objectSpread(_objectSpread({}, scene), {}, {
        style: currentBackground ? program === null || program === void 0 ? void 0 : program.style : (_scene = scene) === null || _scene === void 0 ? void 0 : _scene.style
      });
      dispatch(setProgram(scene));
      (0, _sendToDatadogWithIds.logProgramChange)(getState, 'toggleProgramSource action');

      // If the source being toggled is a media source
      // end the analytics measure that tracks how long it takes for media to be added/removed from stage.
      if ((0, _sources.isMediaSource)(source.type)) {
        // This measure was started when the media was added/removed to/from stage
        _commonWebAnalytics.commonWebAnalytics.endStudioHostAddedMediaToStage({
          title: source.title,
          fileType: source.type,
          eventDocId: source._id,
          result: 'success'
        });
      }
      dispatch((0, _setSceneLayout["default"])(newSceneLayout));
    }
  };
}
var _default = exports["default"] = toggleSourceProgram;